import React from 'react';
import { FaSpotify, FaPodcast } from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  return (
    <footer className="bg-gray-50 border-t border-gray-100 pt-12 pb-32 md:pb-12 mt-12">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="text-center md:text-left">
            <h3 className="text-lg font-bold text-gray-900">Effekten Play</h3>
            <p className="text-sm text-gray-500 mt-1">
              En del av <a href="https://www.effekten.se" className="text-[#F28423] hover:underline">Effekten.se</a>
            </p>
          </div>
          
          <div className="text-center md:text-right">
             <p className="text-xs text-gray-400">
               © {new Date().getFullYear()} Effekten. Alla rättigheter förbehållna.
             </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;